<template>
  <div v-bind="$attrs" class="box is-shadowless">
    <div class="loader-wrapper"
      :class="{ 'is-active': value }">
      <div class="loader is-loading"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">
.loader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: hsl(0, 0%, 96%);
  opacity: 0;
  z-index: -1;
  transition: opacity .3s;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid gainsboro;
  border-radius: 4px;
  
  .loader {
    height: 80px;
    width: 80px;
  }
  
  &.is-active {
    opacity: 1;
    z-index: 1;
  }
}

.is-loading {
  position: relative;
}
</style>